const styleSheet = (theme: any) => ({
  input: {
    display: (props: any) =>
      (props.overrideStyles && props.overrideStyles.display) || 'inline-block',
    margin: (props: any) =>
      (props.overrideStyles && props.overrideStyles.margin) || '0',
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    '&:-ms-input-placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    caretColor: '#085FE5',
    width: (props: any) =>
      (props.overrideStyles && props.overrideStyles.width) || '100%',
    height: (props: any) =>
      (props.overrideStyles && props.overrideStyles.height) || '72px',
    objectFit: 'contain',
    borderRadius: (props: any) =>
      (props.overrideStyles && props.overrideStyles.borderRadius) || '6px',
    border: (props: any) =>
      (props.overrideStyles && props.overrideStyles.border) ||
      'solid 2px #b7c1e1',
    boxSizing: 'border-box',
    padding: (props: any) =>
      (props.overrideStyles && props.overrideStyles.padding) || '0',
    fontSize: (props: any) =>
      (props.overrideStyles && props.overrideStyles.fontSize) || '14px',
    color: (props: any) =>
      (props.overrideStyles && props.overrideStyles.color) || '#4f5b84',
    fontWeight: (props: any) =>
      (props.overrideStyles && props.overrideStyles.fontWeight) || '300',
    lineHeight: (props: any) =>
      (props.overrideStyles && props.overrideStyles.lineHeight) || '18px',
    backgroundColor: (props: any) =>
      (props.overrideStyles && props.overrideStyles.backgroundColor) || '#FFF',
    fontFamily: "'Museo Sans', sans-serif",
  },
  error: {
    borderColor: '#e60000 !important',
    transition: 'border 500ms',
  },
  label: {
    ...theme.label,
    display: 'block',
    textAlign: 'left',
    paddingLeft: '9px',
    marginBottom: '14px',
    color: '#223762',
    fontWeight: '800',
  },
  hideOnMobile: {},
  '@media (max-width: 900px)': {
    input: {
      height: '64px',
      fontSize: '20px',
    },
    label: {
      fontSize: '10px',
    },
    hideOnMobile: {
      display: 'none',
    },
  },
  limitCharacterText: {
    position: 'absolute',
    fontSize: '12px',
    fontWeight: '300',
    letterSpacing: '0',
    lineHeight: '15px',
    height: '15px',
    width: '115px',
    color: '#FF6969',
    bottom: '-25px',
    left: '8px',
  },
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Inputs/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/components/Inputs/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }